// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.positions-field {
    position: relative;
}
.positions-field__field {}
.positions-field__field img {
    width: 100%;
}
.positions-field__positions {
}
.positions-field__positions__position {
    position: absolute;
    min-width: var(--space-x3);
    min-height: var(--space-x2-and-half);
    width: var(--space-x3);
    height: var(--space-x3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
}
.positions-field__positions__position.display-form.active {
    background: var(--primary-dark-color);
    color: var(--white-color);
}

.positions-field__positions__position.display-form.active .hubicon-account_circle::before,
.positions-field__positions__position.display-simple .hubicon-account_circle::before {
    color: var(--white-color);
}

.positions-field__positions__position.display-form.active p,
.positions-field__positions__position.display-simple p {
    color: var(--white-color);
}
.positions-field__positions__position.display-simple {
    background: var(--primary-dark-color);
    color: var(--white-color);
    border-radius: 50%;
}
.positions-field__positions__position.display-form {
    /* box-shadow: 0px 2px 4px #AAC1B6; */
    background: var(--white-color);
    border-radius: 50%;
}
.positions-field__positions__position.display-form:hover {
    background-color: var(--primary-dark-color);
    color: var(--white-color);
    /* box-shadow: var(--shadow-hover-pb); */
    cursor: pointer;
}

.positions-field__positions__position.display-form:hover .hubicon-account_circle::before,
.positions-field__positions__position.display-form:hover p{
    color: var(--white-color);
}

.positions-field__positions__position.display-form:active {
    background-color: var(--primary-dark-color);
    color: var(--white-color);
}
.positions-field__positions__position.display-form img {
    width: 33%;
}
.positions-field__positions__position p {
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: bold !important;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}


/* First Line */
.pos-por {
    left: calc( 50% - var(--space-and-half) );
    bottom: 0px;
}

/* Back Line */
.pos-li {
    left: 0;
    top: calc( 85% - var(--space-x2-and-half) );
}
.pos-dci {
    left: calc( 25% );
    top: calc( 85% - var(--space-x2-and-half) );
}
.pos-dcd {
    right: calc( 25% );
    top: calc( 85% - var(--space-x2-and-half) );
}
.pos-ld {
    right: 0;
    top: calc( 85% - var(--space-x2-and-half) );
}

/* Center Line */
.pos-ci {
    left: var(--space-quarter);
    top: 57%;
}
.pos-mcd {
    left: calc( 50% - var(--space-and-half) );
    top: 57%;
}
.pos-cad {
    right: var(--space-quarter);
    top: 57%;
}

/* Medium Line */
.pos-mi {
    left: var(--space-quarter);
    top: calc( 53% - var(--space-x2-and-half) );
}
.pos-mc {
    left: calc( 50% - var(--space-and-half) );
    top: calc( 53% - var(--space-x2-and-half) )
}
.pos-md {
    right: var(--space-quarter);
    top: calc( 53% - var(--space-x2-and-half) )
}

/* High Line */
.pos-ei {
    left: var(--space-quarter);
    top: calc( 35% - var(--space-x2-and-half) );
}
.pos-mco {
    left: calc( 50% - var(--space-and-half) );
    top: calc( 35% - var(--space-x2-and-half) );
}
.pos-ed {
    right: var(--space-quarter);
    top: calc( 35% - var(--space-x2-and-half) );
}

/* Last Line */
.pos-dc {
    left: calc( 50% - var(--space-and-half) );
    top: 5%;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/positions-field/PositionsFieldComponent.styles.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;AACtB;AACA,yBAAyB;AACzB;IACI,WAAW;AACf;AACA;AACA;AACA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;AACA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,2CAA2C;IAC3C,yBAAyB;IACzB,wCAAwC;IACxC,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;;;AAGA,eAAe;AACf;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA,cAAc;AACd;IACI,OAAO;IACP,2CAA2C;AAC/C;AACA;IACI,iBAAiB;IACjB,2CAA2C;AAC/C;AACA;IACI,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,QAAQ;IACR,2CAA2C;AAC/C;;AAEA,gBAAgB;AAChB;IACI,0BAA0B;IAC1B,QAAQ;AACZ;AACA;IACI,yCAAyC;IACzC,QAAQ;AACZ;AACA;IACI,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA,gBAAgB;AAChB;IACI,0BAA0B;IAC1B,2CAA2C;AAC/C;AACA;IACI,yCAAyC;IACzC;AACJ;AACA;IACI,2BAA2B;IAC3B;AACJ;;AAEA,cAAc;AACd;IACI,0BAA0B;IAC1B,2CAA2C;AAC/C;AACA;IACI,yCAAyC;IACzC,2CAA2C;AAC/C;AACA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA,cAAc;AACd;IACI,yCAAyC;IACzC,OAAO;AACX","sourcesContent":["\n.positions-field {\n    position: relative;\n}\n.positions-field__field {}\n.positions-field__field img {\n    width: 100%;\n}\n.positions-field__positions {\n}\n.positions-field__positions__position {\n    position: absolute;\n    min-width: var(--space-x3);\n    min-height: var(--space-x2-and-half);\n    width: var(--space-x3);\n    height: var(--space-x3);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n}\n.positions-field__positions__position.display-form.active {\n    background: var(--primary-dark-color);\n    color: var(--white-color);\n}\n\n.positions-field__positions__position.display-form.active .hubicon-account_circle::before,\n.positions-field__positions__position.display-simple .hubicon-account_circle::before {\n    color: var(--white-color);\n}\n\n.positions-field__positions__position.display-form.active p,\n.positions-field__positions__position.display-simple p {\n    color: var(--white-color);\n}\n.positions-field__positions__position.display-simple {\n    background: var(--primary-dark-color);\n    color: var(--white-color);\n    border-radius: 50%;\n}\n.positions-field__positions__position.display-form {\n    /* box-shadow: 0px 2px 4px #AAC1B6; */\n    background: var(--white-color);\n    border-radius: 50%;\n}\n.positions-field__positions__position.display-form:hover {\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n    /* box-shadow: var(--shadow-hover-pb); */\n    cursor: pointer;\n}\n\n.positions-field__positions__position.display-form:hover .hubicon-account_circle::before,\n.positions-field__positions__position.display-form:hover p{\n    color: var(--white-color);\n}\n\n.positions-field__positions__position.display-form:active {\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n}\n.positions-field__positions__position.display-form img {\n    width: 33%;\n}\n.positions-field__positions__position p {\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: bold !important;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n\n\n/* First Line */\n.pos-por {\n    left: calc( 50% - var(--space-and-half) );\n    bottom: 0px;\n}\n\n/* Back Line */\n.pos-li {\n    left: 0;\n    top: calc( 85% - var(--space-x2-and-half) );\n}\n.pos-dci {\n    left: calc( 25% );\n    top: calc( 85% - var(--space-x2-and-half) );\n}\n.pos-dcd {\n    right: calc( 25% );\n    top: calc( 85% - var(--space-x2-and-half) );\n}\n.pos-ld {\n    right: 0;\n    top: calc( 85% - var(--space-x2-and-half) );\n}\n\n/* Center Line */\n.pos-ci {\n    left: var(--space-quarter);\n    top: 57%;\n}\n.pos-mcd {\n    left: calc( 50% - var(--space-and-half) );\n    top: 57%;\n}\n.pos-cad {\n    right: var(--space-quarter);\n    top: 57%;\n}\n\n/* Medium Line */\n.pos-mi {\n    left: var(--space-quarter);\n    top: calc( 53% - var(--space-x2-and-half) );\n}\n.pos-mc {\n    left: calc( 50% - var(--space-and-half) );\n    top: calc( 53% - var(--space-x2-and-half) )\n}\n.pos-md {\n    right: var(--space-quarter);\n    top: calc( 53% - var(--space-x2-and-half) )\n}\n\n/* High Line */\n.pos-ei {\n    left: var(--space-quarter);\n    top: calc( 35% - var(--space-x2-and-half) );\n}\n.pos-mco {\n    left: calc( 50% - var(--space-and-half) );\n    top: calc( 35% - var(--space-x2-and-half) );\n}\n.pos-ed {\n    right: var(--space-quarter);\n    top: calc( 35% - var(--space-x2-and-half) );\n}\n\n/* Last Line */\n.pos-dc {\n    left: calc( 50% - var(--space-and-half) );\n    top: 5%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
